module.exports = __webpack_public_path__ + "static/media/paymentIcon.fa1ebd32.svg";